/*******************************************************************************
 * Copyright     : Copyright (c)  2021 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : GlobalStore.ts
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Redux Store
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : December 16, 2021
 *
 * @Version      : Version 1.0
 *
 * By            : <Author>
 * On            : <Date>
 * Description   : <Description>
 *
 *
 ******************************************************************************/

import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import rootReducer from "stores/GlobalStore/rootReducer";
import { api } from "api";

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), api],
  devTools: process.env.NODE_ENV === "development",
});

export const initialRootState = store.getState();

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
